import React, { useContext, useEffect, useState } from "react";
import "./LoanDetailsMemberView.css";

import InputForm, { AutoCompleteValue } from "../../../Components/InputForm/InputForm";

import { useLocation, useSearchParams } from "react-router-dom";
import { APICall } from "../../../Helpers/Network/APICalls";
import { GetLoanDetailsById, ReplaceSurety, getSuretyDetailsForApproval } from "../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { IconButton, Tooltip, Typography } from "@mui/material";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import { Modal } from "react-bootstrap";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";


import { useNavigate } from "react-router-dom";

const LoanDetailsMember_Repayment = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [RepaymentAmount, setRepaymentAmount] = useState<any>();
  const [TotalRepayAmount, setTotalRepayAmount] = useState("");
  const [Balance,setBalance ] = useState("");
  const [Reason,setReason ] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  let navigate = useNavigate();
  const onClickFunction = async (action: any) => {
    
    // showLoader();
    if (action === "Submit") {
    
      
    } else if (action === "Cancel") {
      navigate(-1);
    } else if (action === "Calculate") {
     
      let bal = RepaymentAmount - 5000;
      setBalance(bal.toString());
      setTotalRepayAmount(bal.toString());
      
    }
    
    // hideLoader();
  };

  const handleCheckboxChange = () => {
    
    setIsChecked(!isChecked);
  };

  const handleTextEvent = async (event: any, field: any) => {
    let value = event.target.value;
    // const regex = /^[0-9]+(\.\d{1,2})?$/; 
    const regex  = /^[0-9]+(.+)?$/;
    if (field === "RepayAmount") {
      if (value === "" || regex.test(value)) {
        // if (value.length > 5) {
        //    value = value.slice(0, 5);
        // }
        // if (value <= 100) {
          setRepaymentAmount(value);
        // }
      }
    }
    if (field === "TotalRepayAmount") {
          setTotalRepayAmount(value);
    }
    if (field === "BalanceAmount") {
          setBalance(value);
    }
    if (field === "reason") {
      setReason(value);
    }
   
  };
  
  return (
  
    <div>
      <div className="m-3 p-3">
        <div className="col-12">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="form-group"></div>
              <label>Repayment Amount</label>
              <InputForm placeholder={""}  value={RepaymentAmount} maxLength={30}   onChange={(e) => handleTextEvent(e, "RepayAmount")} textArea={false} />
            </div>
            <div className="col-lg-5 col-md-3 col-sm-12 mt-5">
            <input autoComplete={AutoCompleteValue} type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
            (I want to apply for amount lesser than minimum amount)

            </div>
           
            <div className="col-lg-3 col-md-6 col-sm-12 mt-5">
            <ButtonComponent
                    className="btn btn-dark"
                    style={{
                      cursor: "pointer",
                    }}
                    icon={""}
                    value={"Calculate"}
                    onClick={() => { onClickFunction("Calculate")
                      
                    }}
                  /> 
              </div>
            </div>
            {isChecked ?(
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group"></div>
                <label>Reason</label>
                <InputForm placeholder={""}  value={Reason}   onChange={(e) => handleTextEvent(e, "reason")} textArea={true} />
              </div>
            </div>): null }

            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group"></div>
                <label>Total Payable</label>
                <InputForm placeholder={""} value={TotalRepayAmount}  isDisabled={true} onChange={(e) => handleTextEvent(e, "TotalRepayAmount")} textArea={false} />
              </div>
            </div>
           
            <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="form-group"></div>
              <label>OutStanding Balance</label>
              <InputForm placeholder={""} value={Balance} isDisabled={true}  onChange={(e) => handleTextEvent(e, "BalanceAmount")} textArea={false} />
            </div>
            
          
        </div>
       
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3" style={{ marginRight: "2rem" }}>
          <div>
            <ButtonForm className="btn btn-submit" style={{ marginLeft: 5 }} id="submit" value="Submit" onClick={() => onClickFunction("Submit")} />
          </div>
          
          <div>
            <ButtonForm className="btn btn-cancel" id="cancel" style={{ marginLeft: 5 }} value="Cancel" onClick={() => onClickFunction("Cancel")} />
          </div>
        </div>     
    </div>
   

  )
  };

export default LoanDetailsMember_Repayment;
